import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class LandingTextBlock extends BaseModel {
  static override constructorName = 'LandingTextBlock'

  readonly name = 'text_block'

  title: string = ''
  text: string = ''
  'background_image': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['background_image'])

      this.background_image = toCroppedImage(data.background_image)
    }
  }
}
